/** Keep the public site independent of the Constructor/editor module graph. */
export function isBalancedPublicRoute(pathname: string, domainSlug?: string): boolean {
  if (domainSlug && domainSlug !== "balanced") return false;
  if (domainSlug !== "balanced" && !/^\/balanced(?:\/|$)/.test(pathname)) return false;
  const path = pathname.replace(/^\/balanced(?=\/|$)/, "") || "/";
  return !/^\/(?:admin|admin-edit|login|auth|app)(?:\/|$)/i.test(path);
}
